import { Controller } from 'react-hook-form';

type Props = {
  name: string;
};

export default function ControlledCheckboxInput({ name }: Props): React.ReactElement {
  return (
    <Controller
      name={name}
      render={({ field }) => (
        <input
          {...field}
          checked={field.value || false}
          id={name}
          aria-describedby="candidates-description"
          type="checkbox"
          className="h-5 w-5 rounded border-gray-300 text-primary-600 focus:ring-primary-300"
        />
      )}
    />
  );
}
